  import { apiNoAuth } from "./conection";

  export const categoryServices = {
  
  // Categorias
  getCategories: async () => {
    try {
      const response = await apiNoAuth.get("/categories");

      const formattedCategories = response.data.map((category) => ({
        id: category.id,
        name: category.name,
        url: `/${category.name.toLowerCase().replace(/\s+/g, "-")}`,
      }));
      
      return formattedCategories;
    } catch (error) {
      console.error("Erro ao buscar categorias:", error);
      throw error;
    }
  },
}